import React from 'react';
import { Button, CardMedia, IconButton, Typography, useMediaQuery } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import { useStylesModalOffer } from './hooks/useStyles';
import { getProductImage } from '../../utils/getProductImage';
import { toAbsoluteUrl } from '../../../../../../_base';
import { useFormatMessage } from '../../../../../hooks';
import { thousands } from '../../../../../utils/utils';
import { IProduct } from '../../../../../interfaces/product';

export function Header({
  product,
  closeModal,
}: {
  product: IProduct;
  closeModal: () => void;
}) {
  const navigate = useNavigate();
  const fm = useFormatMessage();
  const { classes } = useStylesModalOffer();
  const isTablet = useMediaQuery('(max-width:920px)');
  const isMobile = window.innerWidth < 600;

  return (
    <div className={classes.product}>
      {isTablet ? null : (
        <CardMedia
          className={classes.image}
          style={{
            objectFit:
              getProductImage(product) === '/images/placeholder.png' ? 'cover' : 'contain',
          }}
          title={product.name}
          src={getProductImage(product)}
          component='img'
          onError={(e: any) => {
            e.target.src = toAbsoluteUrl('/images/placeholder.png');
          }}
        />
      )}
      <div className={classes.productInfo}>
        <div className={classes.containerProductName}>
          <Typography fontWeight='bold' fontSize={isTablet ? 17 : 34} component='p'>
            {product.name}
          </Typography>
          <IconButton onClick={closeModal} className={classes.btnClose}>
            <Close fontSize={isMobile ? 'small' : 'large'} htmlColor='#181c3280' />
          </IconButton>
        </div>
        <div className={classes.containerParams}>
          <div className={classes.colParamsHeader}>
            <div className={classes.param}>
              <Typography fontWeight='regular' fontSize={isTablet ? 14 : 20} component='p'>
                Part number :
              </Typography>
              <Typography
                marginLeft='8px'
                fontWeight='regular'
                fontSize={isTablet ? 14 : 20}
                component='p'
              >
                {product.sku}
              </Typography>
            </div>
            <div className={classes.param}>
              <Typography fontWeight='regular' fontSize={isTablet ? 14 : 20} component='p'>
                Производитель :
              </Typography>
              <Typography
                marginLeft='8px'
                fontWeight='regular'
                fontSize={isTablet ? 14 : 20}
                component='p'
              >
                {product.promelec_params?.producer_name || product.manufacturer?.name || '-'}
              </Typography>
            </div>
            <div className={classes.param}>
              <Typography fontWeight='regular' fontSize={isTablet ? 14 : 20} component='p'>
                Тип корпуса :
              </Typography>
              <Typography
                marginLeft='8px'
                fontWeight='regular'
                fontSize={isTablet ? 14 : 20}
                component='p'
              >
                {product.package || '-'}
              </Typography>
            </div>
          </div>
          {/* <div className={classes.colParamsHeader}>
            <div className={classes.param}>
              <Typography fontWeight='regular' fontSize={isMobile ? 10 : 20} component='p'>
                Количество товара, доступное под заказа :
              </Typography>
              <Typography
                marginLeft='8px'
                fontWeight='regular'
                fontSize={isMobile ? 10 : 20}
                component='p'
              >
                {thousands(String(product.order_quantity || '-'))}
              </Typography>
            </div>
          </div> */}
        </div>
        <Button
          variant='contained'
          className={classes.editBtn}
          onClick={() => navigate(`/viewproduct/${product.id}`)}
        >
          {fm('read_more')}
        </Button>
      </div>
    </div>
  );
}
